var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.525,
    height: 33.533,
    viewBox: "0 0 33.525 33.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search-icon",
    d: "M37.632,35.6l-9.324-9.411a13.288,13.288,0,1,0-2.017,2.043l9.263,9.35a1.435,1.435,0,0,0,2.025.052A1.444,1.444,0,0,0,37.632,35.6ZM17.866,28.344a10.492,10.492,0,1,1,7.421-3.073A10.427,10.427,0,0,1,17.866,28.344Z",
    transform: "translate(-4.5 -4.493)",
    fill: "#cdcdcd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.bcdc871daf7fc346f02a1573ae84c714.svg";
export { ForwardRef as ReactComponent };